import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { IconComponent } from "../icon/icon.component";
import { RaskPopoverDirective } from "../../directives/popover/rask-popover.directive";
import { NgClass, NgTemplateOutlet, AsyncPipe } from "@angular/common";

@Component({
    selector: "rask-info",
    styleUrls: ["./info.component.scss"],
    templateUrl: "./../icon/icon.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RaskPopoverDirective,
        NgClass,
        NgTemplateOutlet,
        AsyncPipe
    ]
})
export class InfoComponent extends IconComponent implements OnInit {
    @Input() infoIconSolid = true;

    ngOnInit() {
        this.icon = this.infoIconSolid ? "fas fa-info-circle" : "fal fa-info-circle";
    }

}
